import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  //  ###    ###  ##   ##
  //  ## #  # ##  ##   ##
  //  ##  ##  ##  ##   ##
  //  ##      ##   ## ##
  //  ##      ##    ###

  if (document.getElementById('topMv')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const slideItem = document.getElementById('topMv')
    const sliderName = 'topMv'
    const topMvSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（topMvSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      touchRatio: 0.3, // タッチスワイプ感度（0でタッチスワイプ無効）
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },

      autoplay: {
        // オートオプション
        delay: 3000, // 待機時間
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
        //   renderBullet: function(index, className) {
        //     // bulletsの描画内容を改変
        //     const targetImage = $('[data-swiper-slide-index="' + index + '"]')
        //       .find("img")
        //       .attr("src");
        //     return (
        //       '<div class="' +
        //       className +
        //       '"><img src=" ' +
        //       targetImage +
        //       ' " alt="ページ' +
        //       index +
        //       '" /></div>'
        //     );
        //   },
      },
    })
  }
}
